import { FluentBundle, FluentResource } from '@fluent/bundle';
import { createFluentVue } from 'fluent-vue';
import deAllocationDesignerMessages from '../allocation-designer/AllocationDesigner.de.ftl?raw';
import deMessages from '../assets/de.ftl?raw';
import deAllocationSelectionFilterMessages from '../components/AllocationSelectionFilter/AllocationSelectionFilter.de.ftl?raw';
import deAllocationSelectionPanelMessages from '../components/AllocationSelectionPanel/AllocationSelectionPanel.de.ftl?raw';
import deAllocationVariantIndexMessages from '../components/AllocationVariantIndex/AllocationVariantIndex.de.ftl?raw';
import deAllocationVariantSelectionPanelMessages from '../components/AllocationVariantSelectionPanel/AllocationVariantSelectionPanel.de.ftl?raw';
import deCardMessages from '../components/Card/Card.de.ftl?raw';
import deCardTabNavigationMessages from '../components/CardTabNavigation/CardTabNavigation.de.ftl?raw';
import deCopyLinkButtonMessages from '../components/CopyLinkButton/CopyLinkButton.de.ftl?raw';
import deCopyTextButtonMessages from '../components/CopyTextButton/CopyTextButton.de.ftl?raw';
import deEnvironmentWarnBannerMessages from '../components/EnvironmentWarnBanner/EnvironmentWarnBanner.de.ftl?raw';
import deExternalEventsTriStateMessages from '../components/ExternalEventsTriState/ExternalEventsTriState.de.ftl?raw';
import deFederalStatesDotsMessages from '../components/FederalStatesDotsTile/FederalStatesDots.de.ftl?raw';
import deFeedMessages from '../components/Feed/Feed.de.ftl?raw';
import deFormMessages from '../components/Form/Form.de.ftl?raw';
import deInlineCreateAllocationVariantMessages from '../components/InlineCreateAllocationVariant/InlineCreateAllocationVariant.de.ftl?raw';
import deInlineTextEditMessages from '../components/InlineTextEdit/InlineTextEdit.de.ftl?raw';
import deLocationDotsMessages from '../components/LocationDotsTile/LocationDotsTile.de.ftl?raw';
import deMainVariantBadgeButtonMessages from '../components/MainVariantBadgeButton/MainVariantBadgeButton.de.ftl?raw';
import deMainVariantTileWrapperMessages from '../components/MainVariantTileWrapper/MainVariantTileWrapper.de.ftl?raw';
import deMultiLinkMessages from '../components/MultiLink/multilink.de.ftl?raw';
import deNavigationSidebarMessages from '../components/NavigationSidebar/NavigationSidebar.de.ftl?raw';
import deNotFoundPageMessages from '../components/NotFoundPage/NotFoundPage.de.ftl?raw';
import dePhasesTileMessages from '../components/PhasesTile/PhasesTile.de.ftl?raw';
import deScenarioGroupIndexMessages from '../components/ScenarioGroupIndex/ScenarioGroupIndex.de.ftl?raw';
import deScenarioIndexMessages from '../components/ScenarioIndex/ScenarioIndex.de.ftl?raw';
import deScenarioLinkButtonMessages from '../components/ScenarioLinkButton/ScenarioLinkButton.de.ftl?raw';
import deScenarioSwitcherMessages from '../components/ScenarioSwitcher/ScenarioSwitcher.de.ftl?raw';
import deSearchBarMessages from '../components/SearchBar/SearchBar.de.ftl?raw';
import deSingleLocationDotTileMessages from '../components/SingleLocationDotTile/SingleLocationDotTile.de.ftl?raw';
import deTimelineMessages from '../components/Timeline/Timeline.de.ftl?raw';
import deTwoLineDropDownMessages from '../components/TwoLineDropDown/TwoLineDropDown.de.ftl?raw';
import deUserReferenceMessages from '../components/UserReference/UserReference.de.ftl?raw';
import deEventMessages from '../event/event.de.ftl?raw';
import deExternalEventMessages from '../external_event/externalEvent.de.ftl?raw';
import deLocationMessages from '../location/location.de.ftl?raw';
import deProjectMessages from '../project/project.de.ftl?raw';
import deReportMessages from '../report/report.de.ftl?raw';
import deScenarioMessages from '../scenario/scenario.de.ftl?raw';
import deUserMessages from '../user/user.de.ftl?raw';
import deVariantMessages from '../variant/variant.de.ftl?raw';

const deBundle = new FluentBundle('de');
deBundle.addResource(new FluentResource(deMessages));
deBundle.addResource(new FluentResource(deAllocationDesignerMessages));
deBundle.addResource(new FluentResource(deAllocationSelectionFilterMessages));
deBundle.addResource(new FluentResource(deAllocationSelectionPanelMessages));
deBundle.addResource(new FluentResource(deAllocationVariantIndexMessages));
deBundle.addResource(new FluentResource(deAllocationVariantSelectionPanelMessages));
deBundle.addResource(new FluentResource(deCardMessages));
deBundle.addResource(new FluentResource(deEnvironmentWarnBannerMessages));
deBundle.addResource(new FluentResource(deFeedMessages));
deBundle.addResource(new FluentResource(deFormMessages));
deBundle.addResource(new FluentResource(deNavigationSidebarMessages));
deBundle.addResource(new FluentResource(deScenarioGroupIndexMessages));
deBundle.addResource(new FluentResource(deScenarioIndexMessages));
deBundle.addResource(new FluentResource(deSearchBarMessages));
deBundle.addResource(new FluentResource(deTimelineMessages));
deBundle.addResource(new FluentResource(deTwoLineDropDownMessages));
deBundle.addResource(new FluentResource(deLocationMessages));
deBundle.addResource(new FluentResource(deEventMessages));
deBundle.addResource(new FluentResource(deExternalEventMessages));
deBundle.addResource(new FluentResource(deReportMessages));
deBundle.addResource(new FluentResource(deMultiLinkMessages));
deBundle.addResource(new FluentResource(deProjectMessages));
deBundle.addResource(new FluentResource(deVariantMessages));
deBundle.addResource(new FluentResource(deScenarioMessages));
deBundle.addResource(new FluentResource(deUserMessages));
deBundle.addResource(new FluentResource(deLocationDotsMessages));
deBundle.addResource(new FluentResource(deMainVariantTileWrapperMessages));
deBundle.addResource(new FluentResource(deMainVariantBadgeButtonMessages));
deBundle.addResource(new FluentResource(deScenarioLinkButtonMessages));
deBundle.addResource(new FluentResource(deScenarioSwitcherMessages));
deBundle.addResource(new FluentResource(dePhasesTileMessages));
deBundle.addResource(new FluentResource(deExternalEventsTriStateMessages));
deBundle.addResource(new FluentResource(deFederalStatesDotsMessages));
deBundle.addResource(new FluentResource(deSingleLocationDotTileMessages));
deBundle.addResource(new FluentResource(deInlineTextEditMessages));
deBundle.addResource(new FluentResource(deInlineCreateAllocationVariantMessages));
deBundle.addResource(new FluentResource(deCopyLinkButtonMessages));
deBundle.addResource(new FluentResource(deCopyTextButtonMessages));
deBundle.addResource(new FluentResource(deCardTabNavigationMessages));
deBundle.addResource(new FluentResource(deNotFoundPageMessages));
deBundle.addResource(new FluentResource(deUserReferenceMessages));

// Create plugin instance
const fluent = createFluentVue({
    bundles: [deBundle],
    warnMissing: (key) => {
        throw new Error(`Missing translation key: ${key}`);
    },
});

export const $t = fluent.format;
export default fluent;
